import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentSipUpiIntentsComponent } from './payment-sip-upi-intents.component';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
  declarations: [PaymentSipUpiIntentsComponent],
  exports: [PaymentSipUpiIntentsComponent],
  imports: [
    CommonModule,
    MatRippleModule
  ]
})
export class PaymentSipUpiIntentsModule { }
